// import { useSelector } from "react-redux";
// import { selectInventoryTransactionType } from "../../redux/slices/transactionTypeSlice";

// export const ReportsData=()=>{
// const inventoryTransaction=useSelector(selectInventoryTransactionType);
//  const salesReports = [
//     {
//         name: "Daily Sales",
//         link: "/reports?name=DailySales"
//     },
//     {
//         name: "Margin Report",
//         link: "/reports?name=MarginReport"
//     },
//     {
//         name: "Monthly Sales",
//         link: "/reports?name=MonthlySales"
//     },

//     {
//         name: "Top N Customers",
//         link: "/reports?name=TopNCustomers"
//     },
//     {
//         name: "Payment Mode Wise Report",
//         link: "/reports?name=PaymentModeWiseReport"
//     },
//     {
//         name: "Payment Mode Transaction Type Wise Report",
//         link: "/reports?name=PaymentModeTransactionTypeWiseReport"
//     },
//     {
//         name: "Transaction Report",
//         link: "/reports?name=TransactionReport"
//     },
//     {
//         name: "Transaction Detail Report",
//         link: "/reports?name=TransactionDetailReport"
//     },
//     {
//         name: "Profit & Loss",
//         link: "/reports?name=ProfitLoss"
//     },
//     {
//         name: "GSTR1 - Transaction Wise",
//         link: "/reports?name=GSTR1TransactionWise"
//     },
//     {
//         name: "GSTR1 - Transaction Line Item Wise",
//         link: "/reports?name=GSTR1TransactionLineItemWise"
//     },
//     {
//         name: "GSTR1 - B2C",
//         link: "/reports?name=GSTR1B2C"
//     },
//     {
//         name: "GSTR1 - B2B",
//         link: "/reports?name=GSTR1B2B"
//     },
//     {
//         name: "HSN Wise Summary Report",
//         link: "/reports?name=HSNWiseSummaryReport"
//     },
//     {
//         name: "Employee By Product",
//         link: "/reports?name=EmployeeByProduct"
//     },
//     {
//         name: "Product Sold Report",
//         link: "/reports?name=ProductSoldReport"
//     },
//     {
//         name: "Product Type Wise Sold Report",
//         link: "/reports?name=ProductTypeWiseSoldReport"
//     },

//     {
//         name: "Category Wise Transaction Report",
//         link: "/reports?name=CategoryWiseTransactionReport"
//     },
//     {
//         name: "Category Wise Sold Report",
//         link: "/reports?name=CategoryWiseSoldReport"
//     },
//     {
//         name: "Sub Category Wise Sold Report",
//         link: "/reports?name=SubCategoryWiseSoldReport"
//     },
//     {
//         name: "Brand Wise Sold Report",
//         link: "/reports?name=BrandWiseSoldReport"
//     },

// ];

//  const inventoryReports = [
//     { name: "In Stock", link: "/reports?name=InStock" },
//     { name: "Not found in Global Catalog", link: "/reports?name=NotfoundinGlobalCatalog" },
//     { name: "Reported Products", link: "/reports?name=ReportedProducts" },
//     { name: "Purchase Projection", link: "/reports/purchaseprojectionreport" },
//     { name: "Products Sold Online (Last 45 Days) and Currently Out of Stock", link: "/reports?name=ProductsSoldOnlineLast45DaysandCurrentlyOutofStock" },
//     { name: "Products Sold (Last 45 Days) and Currently Out of Stock", link: "/reports?name=ProductsSoldLast45DaysandCurrentlyOutofStock" },


//     { name: "Unique No", link: "/reports?name=UniqueNo" },
//     { name: "Inventory History", link: "/reports?name=InventoryHistory" },
//     { name: "Product Order Report", link: "/reports?name=ProductOrderReport" },
//     { name: "Min Qty Report", link: "/reports?name=MinQtyReport" },
//     { name: "Max Qty Report", link: "/reports?name=MaxQtyReport" },


//     ...inventoryTransaction.map((transaction) => ({
//         name: transaction.TransactionType,
//         link: `/reports?type=Inventory&name=${transaction.TransactionType}&transactionTypeId=${transaction.key}`,
//     })),
//     { name: "Product Wise Total", link: "/reports?name=ProductWiseTotal" },
//     { name: "GSTR 2 Report", link: "/reports?name=GSTR2Report" },
//     { name: "Batch Report", link: "/reports?name=BatchReport" },
//     // { name: "Inventory Sales, Purchase & InStock Qty", link: "/reports?name=InventorySalesPurchaseInStockQty" },
// ]

//  const employeeReports = [
//     { name: "Employee Insight", link: "/reports/emplyoeeinsight" },
//     { name: "Attendance Report", link: "/reports/attendancereport" },
//     { name: "Employee Incentive", link: "/reports/employeeincentive" },
// ]

//  const customerReports = [
//     { name: "Membership Dashboard", link: "/reports/membershipdashboard" },
//     { name: "Customer Reference Report", link: "/reports?name=CustomerReferenceReport" },
//     { name: "Customer Wallet Ledger Report", link: "/reports?name=CustomerWalletLedgerReport" },
//     { name: "Customer OutStanding Ledger Report", link: "/reports?name=CustomerOutStandingLedgerReport" },
//     { name: "Membership Expiry", link: "/reports?name=MembershipExpiry" }
// ]

//  const vendorReports = [
//     {
//         name: "Vendor Ledger",
//         link: "/reports?name=VendorLedger"
//     },
//     {
//         name: "Vendor Due Amount",
//         link: "/reports?name=VendorDueAmount"
//     },
// ]

//  const expenseReports = [
//     { name: "Expense List", link: "/reports?name=ExpenseList" },
//     { name: "Expense By Expense Category", link: "/reports?name=ExpenseByExpenseCategory" },
//     { name: "Expense By Party", link: "/reports?name=ExpenseByParty" },
// ];
//  const loyaltyReports = [
//     { name: "Loyalty Dashboard", link: "/reports/loyaltydashboard" },
//     { name: "Loyalty by Customer", link: "/reports?name=LoyaltyByCustomer" },
//     { name: "Loyalty Ledger", link: "/reports?name=LoyaltyLedger" }

// ];

//  const allReportsData = {
//     "Sales Reports": salesReports,
//     "Inventory Reports": inventoryReports,
//     "Employee Reports": employeeReports,
//     "Customer Reports": customerReports,
//     "Vendor Reports": vendorReports,
//     "Expense Reports": expenseReports,
//     "Loyalty Reports": loyaltyReports
// };

//  return {
//         salesReports,
//         inventoryReports,
//         employeeReports,
//         customerReports,
//         vendorReports,
//         expenseReports,
//         loyaltyReports,
//         allReportsData
//     };
// }


import { useSelector } from "react-redux";
import { selectInventoryTransactionType } from "../../redux/slices/transactionTypeSlice";
import { useAcl } from "./CommonFunctions";
import { selectRegistration, selectUser } from "../../redux/slices/userSlice";

export const ReportsData = () => {
  const inventoryTransaction = useSelector(selectInventoryTransactionType);
    const { getVisibility } = useAcl();
    const registration=useSelector(selectRegistration);
    const user=useSelector(selectUser);
  // const getVisibility = (module, access) => {
  //   let visibility = true;
  //   if (acl) {
  //     if (access === "create")
  //       visibility = acl
  //         .filter((e) => e.id === module)
  //         .map((acl) => acl.perms.create)[0];
  //     else if (access === "read")
  //       visibility = acl
  //         .filter((e) => e.id === module)
  //         .map((acl) => acl.perms.read)[0];
  //     else if (access === "update")
  //       visibility = acl
  //         .filter((e) => e.id === module)
  //         .map((acl) => acl.perms.update)[0];
  //     else if (access === "delete")
  //       visibility = acl
  //         .filter((e) => e.id === module)
  //         .map((acl) => acl.perms.delete)[0];
  //     else if (access === "export")
  //       visibility = acl
  //         .filter((e) => e.id === module)
  //         .map((acl) => acl.perms.export)[0];
  //   }
  //   return visibility ? true : false;
  // };

  const isStaffManager = user?.Role === "Staff Manager";
  const isPowerUser = user?.Role === "Power User";
  const isPincode = registration?.WhiteLabel?.Code === "PINCODE";
  const isPincodeKirana = registration?.EnablePincodeKirana;
  const isPincodeBilling = registration?.EnablePosBillingForPincode && registration?.PincodeIntegration;
  const isPincodeIntegration = registration?.PincodeIntegration && !registration?.EnablePosBillingForPincode;

  // Helper function to convert report name to URL format
  const toUrlName = (name) => name.replace(/\s+/g, '').replace(/&/g, 'And');

  // Common function to filter reports based on visibility
  const filterReports = (reports) => reports.filter(Boolean);

  // Pincode Reports
  const loadPincodeReports = () => {
    const salesReports = [
      {
        name: "Order Report",
        link: `/reports?name=OrderReport`
      },
      {
        name: "Item Report",
        link: `/reports?name=ItemReport`
      }
    ];

    // Add Customer Report for specific registration keys
    const specialKeys = [
      "JbCXYlNPSt8XoqgX5nvm", "4kyrBQkxLZR5D0A3eKux", "KPLVQpkYE34hsM9zhtjk",
      "7hznWEWjUB6dPfYLCQyj", "trp6HCyvfWQxbUPXFsGM", "uHPANFUocT8XMDnjtEr4",
      "Ws4daVIcDrRVgsfK3fSf", "9Gz1FLaEQuelaitw4uXe", "MJBko82qp5N3AtAR73Ux",
      "7MR8EhP9hKVxU1teSLB4", "XNC8CcA4rdS0wyFaQfEz", "Njani9l6wA7EJYGmWGjR",
      "rtAxwvzVm3LkUtv0TPQm", "ToFNLPtQMmvdeoqFkkjF", "uHPANFUocT8XMDnjtEr4",
      "1RpFkiKniN4ulNGtFDYQ", "NoT4amt6ixBKILm4I8jF", "p39XGPeMb8RgDQGG8QgU",
      "m1FhORcls9dsPE0UtxNi", "jMOJSlPwHYiaPMWmsKhL", "wBOBvMXgyNuXEU0XDNfZ",
      "DkrUAD2Ym9ttneXCDfM0", "AP6nvkKK58aDPaPJy7w1"
    ];

    if (specialKeys.includes(registration?.key)) {
      salesReports.push({
        name: "Customer Report",
        link: `/reports?name=CustomerReport`
      });
    }

    return {
      salesReports,
      inventoryReports: [],
      employeeReports: [],
      customerReports: [],
      vendorReports: [],
      expenseReports: [],
      loyaltyReports: []
    };
  };

  // Pincode Billing Reports
  const loadPincodeBillingReports = () => {
    //console.log("inventoryTransaction",inventoryTransaction)
    const salesReports = [
      (getVisibility("DailySales", "read") || isStaffManager) && {
        name: "Daily Sales",
        link: `/reports?name=DailySales`
      },
      registration?.EnableMarginReport && {
        name: "Margin Report",
        link: `/reports?name=MarginReport`
      },
      (getVisibility("PaymentModeTransactionTypeWiseReport", "read") || isStaffManager) && {
        name: "Payment Mode Transaction Type Wise Report",
        link: `/reports?name=PaymentModeTransactionTypeWiseReport`
      },
      (getVisibility("TransactionReport", "read") || isStaffManager) && {
        name: "Transaction Report",
        link: `/reports?name=TransactionReport`
      },
      (getVisibility("TransactionDetailReport", "read") || isStaffManager) && {
        name: "Transaction Detail Report",
        link: `/reports?name=TransactionDetailReport`
      },
      (getVisibility("GSTR1TransactionWise", "read") || isStaffManager) && {
        name: "GSTR1 - Transaction Wise",
        link: `/reports?name=GSTR1TransactionWise`
      },
      (getVisibility("GSTR1TransactionLineItemWise", "read") || isStaffManager) && {
        name: "GSTR1 - Transaction Line Item Wise",
        link: `/reports?name=GSTR1TransactionLineItemWise`
      },
      (getVisibility("HSNWiseSummaryReport", "read") || isStaffManager) && {
        name: "HSNWiseSummaryReport",
        link: `/reports?name=HSNWiseSummaryReport`
      },
      (getVisibility("ProductSoldReport", "read") || isStaffManager) && {
        name: "Product Sold Report",
        link: `/reports?name=ProductSoldReport`
      },
      (getVisibility("BrandWiseSoldReport", "read") || isStaffManager) && {
        name: "Brand Wise Sold Report",
        link: `/reports?name=BrandWiseSoldReport`
      }
    ];

    const inventoryReports = [
      (getVisibility("InStock", "read") || isStaffManager) && {
        name: "In Stock",
        link: `/reports/instockreport`
      },
      registration?.EnablePosBillingForPincode && {
        name: "Not found in Global Catalog",
        link: `/reports?name=NotfoundinGlobalCatalog`
      },
      registration?.EnablePosBillingForPincode && {
        name: "Reported Products",
        link: `/reports?name=ReportedProducts`
      },
      registration?.EnablePosBillingForPincode && {
        name: "Purchase Projection",
        link: `/reports/purchaseprojectionreport`
      },
      registration?.EnablePosBillingForPincode && {
        name: "Products Sold Online (Last 45 Days) and Currently Out of Stock",
        link: `/reports?name=ProductsSoldOnlineLast45DaysandCurrentlyOutofStock`
      },
      registration?.EnablePosBillingForPincode && {
        name: "Products Sold (Last 45 Days) and Currently Out of Stock",
        link: `/reports?name=ProductsSoldLast45DaysandCurrentlyOutofStock`
      },
      (getVisibility("MinQtyReport", "read") || isStaffManager) && {
        name: "Min Qty Report",
        link: `/reports?name=MinQtyReport`
      },
      ...inventoryTransaction
        .filter(e => e.Module === "inventory" && !e.IsDeleted)
        .filter(e => getVisibility(e.TransactionType, "read") || isStaffManager)
        .map(e => ({
          name: e.TransactionType,
          link: `/reports?type=Inventory&name=${toUrlName(e.TransactionType)}&transactionTypeId=${e.key}`
        })),
       
      getVisibility("GSTR2TransactionWiseReport", "read") && {
        name: "GSTR 2 Transaction Wise Report",
        link: `/reports?name=GSTR2TransactionWiseReport`
      },
       { name: "Product Wise Total", link: "/reports?name=ProductWiseTotal" },
      isPowerUser && getVisibility("GSTR2TransactionLineItemReport", "read") && {
        name: "GSTR 2 Transaction Line Item Report",
        link: `/reports?name=GSTR2Report`
      }
    ];

    const employeeReports = [
      (getVisibility("AttendanceReport", "read") || isStaffManager) && {
        name: "Attendance Report",
        link: `/reports/attendancereport`
      }
    ];

    const customerReports = [
      (getVisibility("CustomerOutstandingLedger", "read") || isStaffManager) && {
        name: "Customer Outstanding Ledger",
        link: `/reports?name=CustomerOutStandingLedgerReport`
      }
    ];

    const vendorReports = [
      {
        name: "Vendor Ledger",
        link: `/reports?name=VendorLedger`
      },
      {
        name: "Vendor Due Amount",
        link: `/reports?name=VendorDueAmount`
      }
    ];

    const expenseReports = [
      getVisibility("ExpenseList", "read") && {
        name: "ExpenseList",
        link: `/reports?name=ExpenseList`
      }
    ];

    return {
      salesReports: filterReports(salesReports),
      inventoryReports: filterReports(inventoryReports),
      employeeReports: filterReports(employeeReports),
      customerReports: filterReports(customerReports),
      vendorReports: filterReports(vendorReports),
      expenseReports: filterReports(expenseReports),
      loyaltyReports: []
    };
  };

  // Pincode Kirana Reports
  const loadPincodeKiranaReports = () => {
    const salesReports = [
      getVisibility("Daily Sales", "read") && {
        name: "Daily Sales",
        link: `/reports?name=DailySales`
      },
      registration?.EnableMarginReport && {
        name: "Margin Report",
        link: `/reports?name=MarginReport`
      },
      getVisibility("Payment Mode Transaction Type Wise Report", "read") && {
        name: "Payment Mode Transaction Type Wise Report",
        link: `/reports?name=PaymentModeTransactionTypeWiseReport`
      },
      getVisibility("Transaction Wise", "read") && {
        name: "Transaction Report",
        link: `/reports?name=TransactionReport`
      },
      getVisibility("Invoice Detail Report", "read") && {
        name: "Transaction Detail Report",
        link: `/reports?name=TransactionDetailReport`
      },
      getVisibility("GSTR 1 Report", "read") && {
        name: "GSTR1 - Transaction Wise",
        link: `/reports?name=GSTR1TransactionWise`
      },
      getVisibility("GSTR 1 Report", "read") && {
        name: "GSTR1 - Transaction Line Item Wise",
        link: `/reports?name=GSTR1TransactionLineItemWise`
      }
    ];

    const inventoryReports = [
      getVisibility("In Stock", "read") && {
        name: "In Stock",
        link: `/reports/instockreport`
      },
      ...inventoryTransaction
        .filter(e => e.Module === "inventory" && !e.IsDeleted)
        .filter(e => getVisibility(e.TransactionType, "read"))
        .map(e => ({
          name: e.TransactionType,
          link: `/reports?type=Inventory&name=${toUrlName(e.TransactionType)}&transactionTypeId=${e.key}`
        }))
    ];

    return {
      salesReports: filterReports(salesReports),
      inventoryReports: filterReports(inventoryReports),
      employeeReports: [],
      customerReports: [],
      vendorReports: [],
      expenseReports: [],
      loyaltyReports: []
    };
  };

  // Standard Reports
  const loadStandardReports = () => {
     let config={"WhiteLabel":{"Code":"POSIBLE"}}
    const salesReports = [
      (registration?.key === "INZWhIrcdykiinoNqST9" || registration?.key === "HM3hq6TxeFm38cdjcsF0") && 
      getVisibility("PincodeDashboard", "read") && {
        name: "Pincode dashboard",
        link: `/reports?name=PincodeDashboard`
      },
      getVisibility("DailySales", "read") && {
        name: "Daily Sales",
        link: `/reports?name=DailySales`
      },
      getVisibility("MonthlySales", "read") && {
        name: "Monthly Sales",
        link: `/reports?name=MonthlySales`
      },
      getVisibility("TopNCustomers", "read") && {
        name: "Top N Customers",
        link: `/reports?name=TopNCustomers`
      },
      getVisibility("PaymentModeWiseReport", "read") && {
        name: "Payment Mode Wise Report",
        link: `/reports?name=PaymentModeWiseReport`
      },
      getVisibility("PaymentModeTransactionTypeWiseReport", "read") && {
        name: "Payment Mode Transaction Type Wise Report",
        link: `/reports?name=PaymentModeTransactionTypeWiseReport`
      },
      getVisibility("TransactionReport", "read") && {
        name: "Transaction Report",
        link: `/reports?name=TransactionReport`
      },
      getVisibility("TransactionDetailReport", "read") && {
        name: "Transaction Detail Report",
        link: `/reports?name=TransactionDetailReport`
      },
      getVisibility("ProfitLossReport", "read") && {
        name: "Profit & Loss",
        link: `/reports?name=ProfitAndLoss`
      },
      getVisibility("GSTR1TransactionWise", "read") && {
        name: "GSTR1 - Transaction Wise",
        link: `/reports?name=GSTR1TransactionWise`
      },
      getVisibility("GSTR1TransactionLineItemWise", "read") && {
        name: "GSTR1 - Transaction Line Item Wise",
        link: `/reports?name=GSTR1TransactionLineItemWise`
      },
      getVisibility("GSTR1B2C", "read") && {
        name: "GSTR1 - B2C",
        link: `/reports?name=GSTR1B2C`
      },
      getVisibility("GSTR1B2B", "read") && {
        name: "GSTR1 - B2B",
        link: `/reports?name=GSTR1B2B`
      },
      getVisibility("HSNWiseSummaryReport", "read") && {
        name: "HSN Wise Summary Report",
        link: `/reports?name=HSNWiseSummaryReport`
      },
      getVisibility("EmployeeByProduct", "read") && {
        name: "Employee By Product",
        link: `/reports?name=EmployeeByProduct`
      },
      getVisibility("ProductSoldReport", "read") && {
        name: "Product Sold Report",
        link: `/reports?name=ProductSoldReport`
      },
      getVisibility("ProductTypeWiseSoldReport", "read") && {
        name: "Product Type Wise Sold Report",
        link: `/reports?name=ProductTypeWiseSoldReport`
      },
      getVisibility("CategoryWiseTransactionReport", "read") && {
        name: "Category Wise Transaction Report",
        link: `/reports?name=CategoryWiseTransactionReport`
      },
      getVisibility("CategoryWiseSoldReport", "read") && {
        name: "Category Wise Sold Report",
        link: `/reports?name=CategoryWiseSoldReport`
      },
      getVisibility("SubCategoryWiseSoldReport", "read") && {
        name: "Sub Category Wise Sold Report",
        link: `/reports?name=SubCategoryWiseSoldReport`
      },
      getVisibility("BrandWiseSoldReport", "read") && {
        name: "Brand Wise Sold Report",
        link: `/reports?name=BrandWiseSoldReport`
      },
      getVisibility("OfferReport", "read") && {
        name: "Offer Report",
        link: `/reports?name=OfferReport`
      },
      getVisibility("CouponReport", "read") && {
        name: "Coupon Report",
        link: `/reports?name=CouponReport`
      }
    ];

    const inventoryReports = [
      getVisibility("InStock", "read") && {
        name: "In Stock",
        link: `/reports/instockreport`
      },
      getVisibility("UniqueNo", "read") && {
        name: "Unique No",
        link: `/reports?name=UniqueNo`
      },
      getVisibility("InventoryHistory", "read") && {
        name: "Inventory History",
        link: `/reports?name=InventoryHistory`
      },
      getVisibility("ProductOrderReport", "read") && {
        name: "Product Order Report",
        link: `/reports?name=ProductOrderReport`
      },
      getVisibility("MinQtyReport", "read") && {
        name: "Min Qty Report",
        link: `/reports?name=MinQtyReport`
      },
      getVisibility("MaxQtyReport", "read") && {
        name: "Max Qty Report",
        link: `/reports?name=MaxQtyReport`
      },
      ...inventoryTransaction
        .filter(e => e.Module === "inventory" && !e.IsDeleted)
        .filter(e => getVisibility(e.TransactionType, "read"))
        .map(e => ({
          name: e.TransactionType,
          link: `/reports?type=Inventory&name=${toUrlName(e.TransactionType)}&transactionTypeId=${e.key}`
        })),
               { name: "Product Wise Total", link: "/reports?name=ProductWiseTotal" },
      getVisibility("GSTR2TransactionWiseReport", "read") && {
        name: "GSTR 2 Transaction Wise Report",
        link: `/reports?name=GSTR2TransactionWiseReport`
      },

      getVisibility("GSTR2Report", "read") && {
        name: "GSTR 2 Report",
        link: `/reports?name=GSTR2Report`
      },
      {
        name: "Batch Report",
        link: `/reports?name=BatchReport`
      },
      // {
      //   name: "Inventory Sales, Purchase & InStock Qty",
      //   link: `/reports?name=InventorySalesPurchaseAndInStockQty`
      // }
    ];

    const employeeReports = config?.WhiteLabel?.Code !== "PINCODE" ? [
      getVisibility("Employee Insight", "read") && {
        name: "Employee Insight",
        link: `/reports/emplyoeeinsight`
      },
      getVisibility("Attendance", "read") && {
        name: "Attendance Report",
        link: `/reports/attendancereport`
      },
      {
        name: "Employee Incentive",
        link: `/reports/employeeincentive`
      }
    ] : [];

    const customerReports = config?.WhiteLabel?.Code !== "PINCODE" ? [
      getVisibility("Membership Dashboard", "read") && {
        name: "Membership Dashboard",
        link: `/reports/membershipdashboard`
      },
      getVisibility("Customer Reference Report", "read") && {
        name: "Customer Reference Report",
        link: `/reports?name=CustomerReferenceReport`
      },
      getVisibility("Customer Wallet Ledger Report", "read") && {
        name: "Customer Wallet Ledger Report",
        link: `/reports?name=CustomerWalletLedgerReport`
      },
      getVisibility("Customer OutStanding Ledger Report", "read") && {
        name: "Customer OutStanding Ledger Report",
        link: `/reports?name=CustomerOutStandingLedgerReport`
      },
      getVisibility("Membership Expiry", "read") && {
        name: "Membership Expiry",
        link: `/reports?name=MembershipExpiry`
      }
    ] : [];

    const vendorReports = config?.WhiteLabel?.Code !== "PINCODE" ? [
      (user?.hasOwnProperty("RoleKey") && user?.RoleKey !== "") ? [
        getVisibility("Vendor Ledger", "read") && {
          name: "Vendor Ledger",
          link: `/reports?name=VendorLedger`
        },
        getVisibility("Vendor Due Amount", "read") && {
          name: "Vendor Due Amount",
          link: `/reports?name=VendorDueAmount`
        }
      ] : [
        {
          name: "Vendor Ledger",
          link: `/reports?name=VendorLedger`
        },
        {
          name: "Vendor Due Amount",
          link: `/reports?name=VendorDueAmount`
        }
      ]
    ].flat() : [];

    const expenseReports = config?.WhiteLabel?.Code !== "PINCODE" ? [
      getVisibility("Expense List", "read") && {
        name: "Expense List",
        link: `/reports?name=ExpenseList`
      },
      getVisibility("Expense By Expense Category", "read") && {
        name: "Expense By Expense Category",
        link: `/reports?name=ExpenseByExpenseCategory`
      },
      getVisibility("Expense By Expense Category", "read") && {
        name: "Expense By Party",
        link: `/reports?name=ExpenseByParty`
      }
    ] : [];
    console.log("loyaltyEnabled",registration);
    const loyaltyReports = (config?.WhiteLabel?.Code !== "PINCODE" && 
      registration?.hasOwnProperty("LoyaltyEnabled") && 
      registration?.LoyaltyEnabled) ? [
      getVisibility("LoyaltyDashboard", "read") && {
        name: "Loyalty Dashboard",
        link: `/reports/loyaltydashboard`
      },
      getVisibility("LoyaltyCustomer", "read") && {
        name: "Loyalty by Customer",
        link: `/reports?name=LoyaltyByCustomer`
      },
      getVisibility("LoyaltyLedger", "read") && {
        name: "Loyalty Ledger",
        link: `/reports?name=LoyaltyLedger`
      }
    ] : [];

    return {
      salesReports: filterReports(salesReports),
      inventoryReports: filterReports(inventoryReports),
      employeeReports: filterReports(employeeReports),
      customerReports: filterReports(customerReports),
      vendorReports: filterReports(vendorReports),
      expenseReports: filterReports(expenseReports),
      loyaltyReports: filterReports(loyaltyReports)
    };
  };

  // Determine which reports to load based on registration
  let reports;
  if (isPincodeKirana) {
    reports = loadPincodeKiranaReports();
  } else if (isPincodeIntegration) {
    reports = loadPincodeReports();
  } else if (isPincodeBilling) {
    reports = loadPincodeBillingReports();
  } else {
    reports = loadStandardReports();
  }

  // Add WRX specific reports if needed
  if (registration?.WhiteLabel?.Code === "WRX") {
    reports.productReports = [
      {
        name: "Product Export",
        link: `/reports?name=ProductExport`
      }
    ];
  }

  const allReportsData = {
    "Sales Reports": reports.salesReports,
    "Inventory Reports": reports.inventoryReports,
    "Employee Reports": reports.employeeReports,
    "Customer Reports": reports.customerReports,
    "Vendor Reports": reports.vendorReports,
    "Expense Reports": reports.expenseReports,
    "Loyalty Reports": reports.loyaltyReports,
    ...(reports.productReports ? { "Product Reports": reports.productReports } : {})
  };

  return {
    ...reports,
    allReportsData
  };
};